/**
 * Piccadilly cart page — apply / remove discount codes via Cart Ajax API.
 * Does not call theme-cart.refresh(): GET ?sections=main-cart ignores template settings.
 */
(function () {
  if (customElements.get('lop-cart-discount')) return;

  function cartUpdateUrl() {
    var base = (window.theme && theme.routes && theme.routes.cart_update_url) || '/cart/update';
    return base.indexOf('.js') === -1 ? base + '.js' : base;
  }

  function codeMatches(left, right) {
    return String(left || '').trim().toLowerCase() === String(right || '').trim().toLowerCase();
  }

  function unwrapDiscountApp(discount) {
    if (!discount) return {};
    var nested = discount.discount_application;
    if (nested) {
      return {
        title: nested.title || discount.title || '',
        type: nested.type || discount.type || '',
        value: nested.value,
        value_type: nested.value_type,
        total_allocated_amount:
          Number(discount.amount) ||
          Number(nested.total_allocated_amount) ||
          Number(discount.total_allocated_amount) ||
          0
      };
    }
    return {
      title: discount.title || '',
      type: discount.type || '',
      value: discount.value,
      value_type: discount.value_type,
      total_allocated_amount: Number(discount.total_allocated_amount) || Number(discount.amount) || 0
    };
  }

  function allocatedForCode(cart, pending) {
    var cartLevel = 0;
    (cart.cart_level_discount_applications || []).forEach(function (discount) {
      var app = unwrapDiscountApp(discount);
      if (codeMatches(app.title, pending)) {
        cartLevel += Number(app.total_allocated_amount) || 0;
      }
    });
    if (cartLevel > 0) return cartLevel;

    var lineLevel = 0;
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        var application = unwrapDiscountApp(allocation);
        if (codeMatches(application.title, pending) || codeMatches(allocation.title, pending)) {
          lineLevel += Number(allocation.amount) || Number(application.total_allocated_amount) || 0;
        }
      });
    });
    if (lineLevel > 0) return lineLevel;

    var itemDiscounts = 0;
    (cart.items || []).forEach(function (item) {
      (item.discounts || []).forEach(function (discount) {
        if (codeMatches(discount.title, pending)) {
          itemDiscounts += Number(discount.amount) || 0;
        }
      });
    });
    return itemDiscounts;
  }

  function cartDiscountCents(cart) {
    var fromField = Number(cart.total_discount) || 0;
    if (fromField > 0) return fromField;

    var original = Number(cart.original_total_price) || 0;
    var current = Number(cart.total_price) || 0;
    if (original > current) return original - current;

    var lineDelta = 0;
    (cart.items || []).forEach(function (item) {
      var orig = Number(item.original_line_price) || 0;
      var line = Number(item.line_price) || 0;
      if (orig > line) lineDelta += orig - line;
    });
    return lineDelta;
  }

  function discountRows(cart) {
    var rows = [];
    var apps = cart.cart_level_discount_applications || [];
    var codes = appliedCodeList(cart);

    function pushRow(title, cents, percent) {
      rows.push({
        title: title || '',
        cents: Number(cents) || 0,
        percent: percent || null
      });
    }

    if (apps.length) {
      apps.forEach(function (discount) {
        var app = unwrapDiscountApp(discount);
        var title = app.title || (codes[0] || '');
        var cents = Number(app.total_allocated_amount) || 0;
        if (cents <= 0) cents = allocatedForCode(cart, title);
        if (cents <= 0 && apps.length === 1) cents = cartDiscountCents(cart);
        pushRow(title, cents, findPercentForCode(cart, title));
      });
    } else {
      codes.forEach(function (code) {
        var cents = allocatedForCode(cart, code);
        if (cents <= 0) cents = cartDiscountCents(cart);
        pushRow(code, cents, findPercentForCode(cart, code));
      });
    }

    return rows.filter(function (row) {
      return row.cents > 0 || row.percent || row.title;
    });
  }

  function findPercentForCode(cart, pending) {
    var apps = (cart.cart_level_discount_applications || []).map(unwrapDiscountApp);
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_applications || []).forEach(function (discount) {
        apps.push(unwrapDiscountApp(discount));
      });
    });
    var match = apps.filter(function (discount) {
      return codeMatches(discount.title, pending);
    })[0];
    if (!match || String(match.value_type || '') !== 'percentage') return null;
    var percent = Math.round(parseFloat(match.value) || 0);
    return percent > 0 ? percent : null;
  }

  function cartHasOtherDiscount(cart, pending) {
    var otherCode = (cart.discount_codes || []).some(function (entry) {
      return !codeMatches(entry.code, pending) && entry.applicable === true;
    });
    if (otherCode) return true;

    var otherCart = (cart.cart_level_discount_applications || []).some(function (discount) {
      return !codeMatches(unwrapDiscountApp(discount).title, pending);
    });
    if (otherCart) return true;

    return (cart.items || []).some(function (item) {
      return (item.line_level_discount_applications || []).some(function (discount) {
        return !codeMatches(discount.title, pending);
      });
    });
  }

  function classifyDiscountResult(cart, pending) {
    var codes = (cart && cart.discount_codes) || [];
    var discountCode = codes.filter(function (entry) {
      return codeMatches(entry.code, pending);
    })[0];
    var percent = findPercentForCode(cart, pending);

    if (discountCode && discountCode.applicable === true) {
      return { status: 'success', percent: percent, allocated: allocatedForCode(cart, pending) };
    }
    if (discountCode && discountCode.applicable === false && cartHasOtherDiscount(cart, pending)) {
      return { status: 'not_combined' };
    }
    return { status: 'error' };
  }

  function formatMoney(cents, currency) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: currency || 'ARS',
        maximumFractionDigits: 0
      }).format(amount);
    } catch (err) {
      return '$' + Math.round(amount).toLocaleString('es-AR');
    }
  }

  function appliedCodeList(cart) {
    var codes = [];
    (cart.discount_codes || []).forEach(function (entry) {
      if (entry && entry.applicable && entry.code && codes.indexOf(entry.code) === -1) {
        codes.push(entry.code);
      }
    });
    if (codes.length) return codes;

    (cart.cart_level_discount_applications || []).forEach(function (discount) {
      var app = unwrapDiscountApp(discount);
      if (app.type === 'discount_code' && app.title && codes.indexOf(app.title) === -1) {
        codes.push(app.title);
      }
    });
    return codes;
  }

  class LopCartDiscount extends HTMLElement {
    connectedCallback() {
      if (this.dataset.lopCartDiscountInited === 'true') return;
      this.dataset.lopCartDiscountInited = 'true';
      this.input = this.querySelector('[data-lop-cart-discount-input]');
      this.applyButton = this.querySelector('[data-lop-cart-discount-apply]');
      this.message = this.querySelector('[data-lop-cart-discount-message]');
      this.bindEvents();
    }

    bindEvents() {
      if (this.applyButton) {
        this.applyButton.addEventListener('click', this.onApply.bind(this));
      }
      if (this.input) {
        this.input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.onApply();
          }
        }.bind(this));
      }
      this.bindRemoveButtons();
    }

    bindRemoveButtons() {
      this.querySelectorAll('[data-lop-cart-discount-remove]').forEach(function (button) {
        if (button.dataset.lopBound === 'true') return;
        button.dataset.lopBound = 'true';
        button.addEventListener('click', function () {
          this.onRemove(button.getAttribute('data-lop-cart-discount-code'));
        }.bind(this));
      }.bind(this));
    }

    appliedCodes() {
      return Array.from(this.querySelectorAll('[data-lop-cart-discount-code]'))
        .map(function (node) {
          return (node.getAttribute('data-lop-cart-discount-code') || '').trim();
        })
        .filter(Boolean);
    }

    setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
      this.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      if (this.applyButton) this.applyButton.disabled = isLoading;
      if (this.input) this.input.disabled = isLoading;
    }

    messageFor(status, percent, amountCents, currency) {
      if (status === 'success') {
        var amountText = amountCents > 0 ? formatMoney(amountCents, currency) : '';
        if (amountText) {
          return (this.getAttribute('data-msg-success') || 'Código aplicado') + ' (−' + amountText + ')';
        }
        if (percent) {
          return String(this.getAttribute('data-msg-success-percent') || '').replace(/__PCT__/g, String(percent));
        }
      }
      var map = {
        success: 'data-msg-success',
        empty: 'data-msg-empty',
        already: 'data-msg-already',
        not_combined: 'data-msg-not-combined',
        error: 'data-msg-invalid',
        network: 'data-msg-network'
      };
      return this.getAttribute(map[status] || 'data-msg-invalid') || '';
    }

    showMessage(status, percent, amountCents, currency) {
      if (!this.message) return;
      var text = this.messageFor(status, percent, amountCents, currency);
      this.message.textContent = text;
      this.message.classList.remove('is-error', 'is-success', 'is-warning');
      if (status === 'success') {
        this.message.classList.add('is-success');
      } else if (status === 'not_combined') {
        this.message.classList.add('is-warning');
      } else {
        this.message.classList.add('is-error');
      }
      this.message.hidden = !text;
    }

    onApply() {
      var code = ((this.input && this.input.value) || '').trim();
      if (!code) {
        this.showMessage('empty');
        return;
      }

      var existing = this.appliedCodes();
      if (existing.some(function (applied) { return codeMatches(applied, code); })) {
        this.showMessage('already');
        return;
      }

      this.submitDiscount(existing.concat([code]).join(','), code, false);
    }

    onRemove(code) {
      if (!code) return;
      var nextCodes = this.appliedCodes()
        .filter(function (applied) { return !codeMatches(applied, code); })
        .join(',');
      this.submitDiscount(nextCodes, code, true);
    }

    submitDiscount(discountValue, pendingCode, isRemove) {
      this.setLoading(true);
      fetch(cartUpdateUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ discount: discountValue })
      })
        .then(function (response) {
          return response.text().then(function (text) {
            var payload = {};
            try {
              payload = text ? JSON.parse(text) : {};
            } catch (err) {
              payload = {};
            }
            return { ok: response.ok, payload: payload };
          });
        })
        .then(function (result) {
          if (!result.ok || (result.payload.status && result.payload.status >= 400)) {
            this.showMessage('network');
            return;
          }

          var cart = result.payload;
          if (isRemove) {
            this.syncCartUi(cart);
            this.showMessage('');
            if (this.message) this.message.hidden = true;
            return;
          }

          var classified = classifyDiscountResult(cart, pendingCode);
          if (classified.status === 'success' && this.input) {
            this.input.value = '';
          }
          if (classified.status === 'success' && !(classified.allocated > 0)) {
            classified.allocated = cartDiscountCents(cart);
          }
          this.syncCartUi(cart);
          this.showMessage(classified.status, classified.percent, classified.allocated, cart.currency);
        }.bind(this))
        .catch(function () {
          this.showMessage('network');
        }.bind(this))
        .finally(function () {
          this.setLoading(false);
        }.bind(this));
    }

    syncCartUi(cart) {
      this.renderChips(cart);
      this.renderTotals(cart);
    }

    renderChips(cart) {
      var codes = appliedCodeList(cart);
      var list = this.querySelector('.lop-cart-discount__chips');
      if (!codes.length) {
        if (list) list.remove();
        return;
      }

      if (!list) {
        list = document.createElement('ul');
        list.className = 'lop-cart-discount__chips';
        this.insertBefore(list, this.message);
      }

      var removeLabel = this.getAttribute('data-msg-remove') || 'Quitar código';

      list.innerHTML = codes.map(function (code) {
        var safe = String(code).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
        return (
          '<li class="lop-cart-discount__chip">' +
            '<span class="lop-cart-discount__chip-code">' + safe + '</span>' +
            '<button type="button" class="lop-cart-discount__chip-remove" data-lop-cart-discount-code="' + safe + '" data-lop-cart-discount-remove aria-label="' + removeLabel + ' ' + safe + '">' +
              '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 2l8 8M10 2L2 10" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>' +
            '</button>' +
          '</li>'
        );
      }).join('');
      this.bindRemoveButtons();
    }

    renderTotals(cart) {
      var table = document.querySelector('.thb-cart-form--collaterals-table tbody');
      if (!table) return;

      table.querySelectorAll('tr.cart-discount').forEach(function (row) {
        row.remove();
      });

      var subtotalRow = table.querySelector('tr.cart-subtotal');
      discountRows(cart).forEach(function (discount) {
        var amountLabel = '';
        if (discount.cents > 0) {
          amountLabel = '-' + formatMoney(discount.cents, cart.currency);
        } else if (discount.percent) {
          amountLabel = '-' + discount.percent + '%';
        } else {
          return;
        }

        var row = document.createElement('tr');
        row.className = 'cart-discount';
        var title = String(discount.title || 'Descuento').replace(/&/g, '&amp;').replace(/</g, '&lt;');
        row.innerHTML =
          '<th>' + title + '</th>' +
          '<td><span class="price"><span class="amount">' + amountLabel + '</span></span></td>';
        if (subtotalRow) {
          table.insertBefore(row, subtotalRow);
        } else {
          table.appendChild(row);
        }
      });

      if (subtotalRow) {
        var amountEl = subtotalRow.querySelector('.amount');
        if (amountEl) amountEl.textContent = formatMoney(cart.total_price, cart.currency);
      }
    }
  }

  customElements.define('lop-cart-discount', LopCartDiscount);
})();
